import { LitElement, html, css } from "lit";
import "./accordeon-item.css";

export class Accordeon extends LitElement {
  static properties = {
    isOpen: { type: Boolean },
    isDark: { type: Boolean },
    noBorder: { type: Boolean },
  };

  constructor() {
    super();
    this.isOpen = false;
  }

  firstUpdated(e) {
    !this.isOpen ? this.close() : this.open();
  }

  static styles = css`
    .header {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      cursor: pointer;
    }
    .header:hover {
      opacity: 0.75;
    }
    .header__title {
      flex: 1;
      font-size: 13px;
      text-transform: uppercase;
      font-weight: 500;
      line-height: 1.85;
      letter-spacing: 1.25px;
    }

    .header__wrapper {
      justify-content: space-between;
      flex: 1;
      display: flex;
    }
    .header__icon {
      transform: rotate(0deg);
      height: 24px;
      width: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 250ms ease;
      margin-right: 78px;
    }
    .header:hover .header__icon {
      transform: scale(1.2) rotate(0deg);
    }
    .--open .header:hover .header__icon,
    .--open .header__icon {
      transform: rotate(90deg);
    }

    .--dark,
    .--dark > * {
      color: white;
    }

    .body {
      height: 100%;
      overflow: hidden;
      max-height: 0;
      transition: max-height 250ms ease;
    }

    .content {
      display: block;
      padding: 0 20px 20px 88px;
    }

    .wrapper {
      border-bottom: 1px solid;
      border-color: #c7c7c7;
    }

    .wrapper.--dark {
      border-color: #505f74;
    }
    .wrapper.--noborder {
      border-bottom: none;
    }

    @media screen and (max-width: 996px) {
      .header__icon {
        margin-right: 30px;
      }
      .content {
        padding-left: 40px;
      }
    }
  `;

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    let contentHeight =
      this.shadowRoot.querySelector(".body .content").clientHeight;
    this.setIsOpen(true);
    this.shadowRoot.querySelector(".body").style.maxHeight =
      contentHeight + "px";
  }

  close() {
    this.setIsOpen(false);
    this.shadowRoot.querySelector(".body").style.maxHeight = 0;
  }
  /**
   *
   * @param {Boolean} val
   */
  setIsOpen(val) {
    this.isOpen = val;
  }

  icon() {
    return html`<svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.542"
      height="9.783"
      viewBox="0 0 10.542 9.783"
    >
      <path
        id="Tracé_690"
        data-name="Tracé 690"
        d="M72.622,31.391,62.08,26.669v9.783Z"
        transform="translate(-62.08 -26.669)"
        fill="#ffd800"
      />
    </svg> `;
  }

  render() {
    return html` <div
      class="wrapper${this.isOpen ? ` --open` : ``} ${this.isDark && ` --dark`}
      ${this.noBorder && `--noborder`}"
    >
      <div class="header" @click=${() => this.toggle()}>
        <div class="header__wrapper">
          <div class="header__icon">${this.icon()}</div>
          <div class="header__title">
            <slot name="title"></slot>
          </div>
        </div>
      </div>
      <div class="body">
        <div class="content">
          <slot name="content"></slot>
        </div>
      </div>
    </div>`;
  }
}

customElements.define("accordeon-item", Accordeon);
